import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import CartItem from '../components/Shop/CartItem'
import { useCart } from '../contexts/CartContext'
import CartSummary from '../components/Shop/CartSummary'
import CartDebug from '../components/Shop/CartDebug'
import { ORDER_INFORMATIONS_PATH } from '../config/routes'
import PageHeroTitle from '../components/PageHeroTitle'

const Cart = () => {
  const { t } = useTranslation()
  const { cartItems, products } = useCart()
  const navigate = useNavigate()

  const hasItemWithoutVariant = cartItems.some(
    (item) => item.product && !item.productVariant,
  )

  const handleProceed = () => {
    navigate(ORDER_INFORMATIONS_PATH)
  }

  return (
    <div>
      {process.env.REACT_APP_TOGGLE_CART_DEBUG === 'true' && <CartDebug />}
      <NavigationBar />

      <PageHeroTitle
        title={t('MY_CART')}
        description=""
      />

      <div className="p-3">

        {cartItems.length === 0 ? (
          <p>{t('YOUR_CART_IS_EMPTY')}</p>
        ) : (
          <div>
            <ul>
              {cartItems.map((item, index) => (
                <CartItem key={index} item={item} products={products} />
              ))}
            </ul>
            <hr />
            <CartSummary />
            <hr />
            {hasItemWithoutVariant && (
              <div className="alert alert-warning text-center">
                {t('CHOOSE_A_VARIANT_FOR_EACH_ITEM')}
              </div>
            )}
            <div style={{ textAlign: 'center' }}>
              <button
                className="btn btn-primary"
                onClick={handleProceed}
                disabled={hasItemWithoutVariant}
              >
                {t('PROCEED_TO_CHECKOUT')}
              </button>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  )
}

export default Cart
